import React, { useState } from "react";
import styled from "styled-components";
import logo from "../../assets/LogoMVBartenders 1.png";

const Header = () => {
  const [bar, setBar] = useState(false);

  // Função para fechar o menu
  const handleItemClick = () => {
    setBar(false);
  };

  return (
    <Container bar={bar}>
      <Logo>
        <img src={logo} alt="Logo" />
      </Logo>
      <Nav bar={bar}>
        <span onClick={handleItemClick}>
          <a href="#quemSomos">Quem Somos</a>
        </span>
        <span onClick={handleItemClick}>
          <a href="#project">Nossos Drinks</a>
        </span>
        <span onClick={handleItemClick}>
          <a href="#nossosServicos">Nossos Serviços</a>
        </span>
        <span onClick={handleItemClick}>
          <a href="#solicitarOrcamento">Solicitar Proposta</a>
        </span>
      </Nav>
      <div onClick={() => setBar(!bar)} className="bars">
        <div className="bar"></div>
      </div>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 1.5rem 0;
  position: relative;
  animation: header 500ms ease-in-out;
  @media (max-width: 840px) {
    width: 90%;
  }
  .bars {
    display: none;
  }
  @media (max-width: 640px) {
    .bars {
      width: 20px;
      height: 20px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5rem;
      z-index: 100;
      .bar {
        position: absolute;
        width: 100%;
        height: 2px;
        background-color: ${(props) => (props.bar ? "transparent" : "#fff")};
        transition: all 400ms ease-in-out;

        :before,
        :after {
          content: "";
          width: 100%;
          height: 2px;
          background-color: #fff;
          position: absolute;
        }

        :before {
          transform: ${(props) =>
            props.bar ? "rotate(45deg)" : "translateY(10px)"};
          transition: all 400ms ease-in-out;
        }

        :after {
          transform: ${(props) =>
            props.bar ? "rotate(-45deg)" : "translateY(-10px)"};
          transition: all 400ms ease-in-out;
        }
      }
    }
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-grow: 1;
  width: 30%;

  img {
    max-width: 30%;
    height: auto;
  }
`;

const Nav = styled.div`
  @media (max-width: 840px) {
    position: fixed;
    display: flex;
    flex-direction: column; /* Alteração para exibir os itens na vertical */
    background-color: #1c1c24;
    inset: 0;
    justify-content: center;
    align-items: left;
    font-size: 1rem;
    gap: 1rem;
    font-weight: 700;
    height: ${(props) => (props.bar ? "30%" : 0)};
    transition: height 400ms ease-in-out;
    overflow: hidden;
    z-index: 100;
  }
  span {
    margin-left: 1rem;
    a {
      color: #fff;
      text-decoration: none;
      font-weight: 400;
      position: relative;
      :before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -5px;
        height: 2px;
        background-color: #fff;
        transform: scale(0);
        transform-origin: right;
        transition: transform 400ms ease-in-out;
      }
      :hover:before {
        transform: scale(1);
        transform-origin: left;
      }
      :hover {
        opacity: 0.7;
      }
    }
  }
`;
